import API, { handleRequest } from '@/api/lib/api'

export const getOrderWiseStatus = params =>
  handleRequest(() => API.get('/online-order/orders', { params }))


export const getOrderDetails = orderId =>
  handleRequest(() => API.get(`/online-order/orders/${orderId}`))


export const orderAccept = orderId =>
  handleRequest(() => API.put(`/online-order/orders/${orderId}/accept`))

export const orderCancel = (orderId) =>
  handleRequest(() => API.put(`/online-order/orders/${orderId}/cancel`))